import { render, staticRenderFns } from "./SignUpForm.vue?vue&type=template&id=875fb6ea&scoped=true&"
import script from "./SignUpForm.vue?vue&type=script&lang=ts&"
export * from "./SignUpForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875fb6ea",
  null
  
)

export default component.exports